// *** This component can be used inside an AccordionGroup ***
<script setup lang="ts">
const emit = defineEmits<{
    (event: 'open'): void, 
    (event: 'close'): void
}>();
const isOpen = defineModel<boolean>({ default: false });

// --------- AccordionGroup logic ---------
const group = inject<{
    registerAccordion: (accordion: TAccordion) => void,
    closeAllAccordions: () => void,
} | null>('accordion-group', null);

if (group)
    group.registerAccordion({ openAccordion, closeAccordion });
// ----------------------------------------
export type TAccordion = {
    openAccordion: ()=>void,
    closeAccordion: ()=>void
};

function openAccordion() {
    if (group) group.closeAllAccordions();
    emit('open');
    isOpen.value = true;
};

function closeAccordion() {
    emit('close');
    isOpen.value = false;
};

function toggleAccordion() {
    if (isOpen.value) closeAccordion();
    else openAccordion();
};
</script>

<template>
    <div class="w-full">
        <slot 
            name="head" 
            :isOpen="isOpen" 
            :toggleAccordion="toggleAccordion"
            :openAccordion="openAccordion"
            :closeAccordion="closeAccordion"
        />
        <div 
            class="w-full grid grid-rows-[0fr] transition-all duration-300 [&>div]:overflow-hidden"
            :class="isOpen && 'grid-rows-[1fr]'"
        >
            <div>
                <slot name="body" :isOpen="isOpen" />
            </div>
        </div>
    </div>
</template>